<template>
  <b-modal id="view_log_modal" ref="view_log_modal" :header-class="['view_log_modal', log_type(log.type)]" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1>
          <span class="log_icon">{{ log.type | capitalLogType }}</span>
          <span class="log_type_name">
            <span v-if="log.log_type === 'worker'"> Worker {{ log.worker_model_type | workerModelLog }}</span>
            <span v-if="log.log_type === 'client'"> Client {{ log.client_model_type | clientModelLog }}</span>
            <span v-if="log.log_type === 'contact'"> Contact {{ log.contact_model_type | contactModelLog }}</span>
            <span id="log_on_name">{{ log_on_name }}</span>
          </span>
        </h1>

        <p id="mh-info">
          <span style="font-size: 0.7rem;">{{ log.type | camel }} by {{ log.log_by.first_name + ' ' + log.log_by.surname }} on {{ log.updated_at | formatDateTime }}</span><br>
          <!--     <span style="font-size: 0.7rem;"></span>-->
        </p>
      </div>
      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <!-- NOTES -->
    <note v-if="model_log === 'Note'" :log="log" :model_log="model_log"></note>
    <!-- Worker -->
    <worker v-if="log.log_type === 'worker' && model_log !== 'Note'" :log="log" :model_log="model_log"></worker>
    <!-- Client -->
    <client v-if="log.log_type === 'client' && model_log !== 'Note'" :log="log" :model_log="model_log"></client>
    <!-- Contact -->
    <contact v-if="log.log_type === 'contact' && model_log !== 'Note'" :log="log" :model_log="model_log"></contact>

  </b-modal>
</template>

<script>
import worker from './worker';
import client from './client';
import contact from './contact';
import note from './note';

export default {
  name: "view_log",
  components: {
    worker,
    client,
    contact,
    note
  },
  data() {
    return {
      log: this.$store.state.logs.log,
      log_on_name: ''
    }
  },
  computed: {
    model_log() {
      if (this.log.log_type === 'worker') {
        return this.$options.filters.workerModelLog(this.log.worker_model_type)
      }
      if (this.log.log_type === 'client') {
        return this.$options.filters.clientModelLog(this.log.client_model_type)
      }
      if (this.log.log_type === 'contact') {
        return this.$options.filters.contactModelLog(this.log.contact_model_type)
      }
    }
  },
  mounted() {
    if (this.log.log_type === 'worker') {
      axios.get(this.crmApiPath + 'worker/' + this.log.worker_id)
          .then(worker => {this.log_on_name = worker.data.person.first_name + ' ' + worker.data.person.surname});
    }
    if (this.log.log_type === 'client' && this.log.type !== 'deleted') {
      axios.get(this.crmApiPath + 'client/' + this.log.client_id)
          .then(client => {this.log_on_name = client.data.client_name});
    }
    if (this.log.log_type === 'contact' && this.log.type !== 'deleted') {
      axios.get(this.crmApiPath + 'contacts/' + this.log.contact_id)
          .then(contact => {this.log_on_name = contact.data.full_name});
    }
  },
  methods: {
    hideModal() {
      this.$refs.view_log_modal.hide();
      this.$store.commit('HIDE_VIEW_LOG_MODAL');
    },
    log_type(type) {
      if (type === 'created') {
        return 'created';
      }
      else if (type === 'updated') {
        return 'updated';
      }
      else if (type === 'restored') {
        return 'restored';
      }
      else if (type === 'deleted') {
        return 'deleted';
      }
    },
  }
}
</script>

<style lang="scss">
.mh {
  .log_icon {
    font-weight:    bold;
    display:        inline-block;
    margin-right:   5px;
    border:         2px solid;
    border-radius:  50%;
    text-align:     center;
    height:         30px;
    width:          30px;
    line-height:    26px;
    padding-left:   1px;
    vertical-align: top;
  }

  .log_type_name {
    display: inline-block;
    width:   calc(100% - 45px);

    span {
      display: block;
      width:   100%;

      &#log_on_name {
        font-size: 1rem;
      }
    }
  }
}

.view_log_modal {
  &.created {
    background-color: $green;

    #mh-close {
      .btn-close {
        &:hover, &:focus, &:active, &:active:focus, &.active.focus {
          background-color: darken($green, 10%) !important;
        }
      }
    }
  }

  &.updated {
    background-color: $blue;

    #mh-close {
      .btn-close {
        &:hover, &:focus, &:active, &:active:focus, &.active.focus {
          background-color: darken($blue, 10%) !important;
        }
      }
    }
  }

  &.restored {
    background-color: $orange;

    #mh-close {
      .btn-close {
        &:hover, &:focus, &:active, &:active:focus, &.active.focus {
          background-color: darken($orange, 10%) !important;
        }
      }
    }
  }

  &.deleted {
    background-color: $red;

    #mh-close {
      .btn-close {
        &:hover, &:focus, &:active, &:active:focus, &.active.focus {
          background-color: darken($red, 10%) !important;
        }
      }
    }
  }
}

#view_log_modal {
  pre {
    font-family:   $font-family-paragraph;
    font-size:     0.8rem;
    margin-bottom: 0;
  }

  .updated_value {
    color: $blue;

    pre {
      color: $blue
    }
  }

  .old_value {
    color: $bc_4;

    pre {
      color: $bc_4
    }
  }

  .updated_note, .original_note {
    padding: 10px;
  }

  .updated_note {
    background: lighten($blue, 25%);
  }

  .record {
    .row {
      margin-bottom: 10px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}
</style>
